module.exports = __webpack_public_path__ + "img/fr.fdfdd4ee.svg";